import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/cross-icon.svg.js';
import '../../atoms/buttons/icon-button/index.js';
import '../global-nav/index.js';
import css_248z from './login-menu.scss.js';
import './sub-nav.js';

class LoginMenu extends s {
    constructor() {
        super(...arguments);
        this.open = false;
        this.goToHomePageText = 'Go to Homepage';
        this.closeButtonText = 'Close Menu';
        this.rtl = false;
    }
    handleClose() {
        this.onClose();
    }
    render() {
        const containerClassMap = {
            rtl: this.rtl || isRTL(),
            'login-menu': true,
        };
        return $ `<div class="${o(containerClassMap)}"><div class="header"><a href="/" aria-label="${this.goToHomePageText}"><slot name="login-menu-logo" alt="" aria-hidden="true"></slot></a><icon-button type="button" styletype="${ButtonStyleTypes.LIGHT}" @click="${this.handleClose}" aria-label="${this.closeButtonText}"><img slot="icon" .src="${img}" alt="" aria-hidden="true"></icon-button></div><div class="login-menu-container"><slot name="login-menu-heading"></slot><slot name="login-menu-description"></slot><div class="login-menu-cta"><slot name="login-buttons"></slot></div></div></div>`;
    }
}
LoginMenu.styles = css_248z;
__decorate([
    e()
], LoginMenu.prototype, "open", void 0);
__decorate([
    e({ type: Function })
], LoginMenu.prototype, "onClose", void 0);
__decorate([
    e()
], LoginMenu.prototype, "goToHomePageText", void 0);
__decorate([
    e()
], LoginMenu.prototype, "closeButtonText", void 0);
__decorate([
    e({ type: Boolean })
], LoginMenu.prototype, "rtl", void 0);
customElements.define('login-menu', LoginMenu);

export { LoginMenu };
